/* Copyright 2021, Milkdown by Mirone. */
export const part = /:\+1|:-1|:[\w-]+/;
export const full = /:\+1:|:-1:|:[\w-]+:/;
export const input = /(:([^:\s]+):)$/;
export const keyword = ':emoji:';
//# sourceMappingURL=constant.js.map